import { render, staticRenderFns } from "./modalverdetalleCS.vue?vue&type=template&id=3ef5a214&"
import script from "./modalverdetalleCS.vue?vue&type=script&lang=ts&"
export * from "./modalverdetalleCS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3ef5a214', component.options)
    } else {
      api.reload('3ef5a214', component.options)
    }
    module.hot.accept("./modalverdetalleCS.vue?vue&type=template&id=3ef5a214&", function () {
      api.rerender('3ef5a214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/modalverdetalleCS.vue"
export default component.exports